import React from "react";
import styles from "./MainButton.module.scss";

type Props = {
  onClick?: () => void;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
  text: string;
  disabled?: boolean;
  type?: "submit";
  className?: string;
  style?: React.CSSProperties;
};

export const MainButton = ({
  onClick,
  onMouseDown,
  onMouseUp,
  style,
  text,
  disabled,
  type,
  className,
}: Props) => {
  return (
    <button
      style={style}
      type={type}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      disabled={disabled}
      onClick={onClick}
      className={[
        styles.MainButton,
        disabled ? styles.Disabled : "",
        className ? className : "",
      ].join(" ")}
    >
      {text}
    </button>
  );
};
